import { REVIEWER_DECISION } from '@/utils/dict'
import { minvitedReviewer } from '@/api/reviewer'
import { mapGetters } from 'vuex'
const columns = [
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Recommendation',
    width: 150,
    dataIndex: 'decisionStatus',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Version',
    width: 100,
    dataIndex: 'sign'
  },
  {
    title: '',
    enTitle: 'Finished Time',
    width: 120,
    dataIndex: 'completedTime',
    slot: 'date'
  }
]
export default {
  data() {
    return {
      columns,
      REVIEWER_DECISION,
      params: {},
      detail: {},
      dataSource: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted() {
    this.params.manuscriptId = this.$route.params.id
    this.decision()
    this.getList()
  },
  methods: {
    async decision() {
      this.detail = await minvitedReviewer.decision(this.params)
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const {
        list,
        pageIndex,
        pageSize,
        total
      } = await minvitedReviewer.alldecision(data)
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    // 查看详情
    showReport(record) {
      this.$router.push(
        `/editorial-office/manuscripts/details/reviews-report/${record.id}?sign=${record.sign}`
      )
    }
  }
}
